import "../../functions/FaqButton";
import "/resources/js/functions/GoogleMap";